<template>
    <el-dialog
      :title="'发单列表'"
      :visible.sync="dialogIsShow"
      width="750px" 
      append-to-body
    >
      <el-table
        :data="jobList"
        v-loading="listLoading"
        stripe
        border
        :header-cell-style="{ background: '#F5F7FA' }"
      >
        <el-table-column property="Id" label="Id" width="80">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.JobNo || "--" }}</span> -->
            <router-link
              style="color: black"
              :to="{ path: '/job/b2bJobInfo', query: { JobId: scope.row.Id } }"
              target="_blank">{{ scope.row.Id || "--" }}</router-link>
          </template>
        </el-table-column> 

        <el-table-column property="JobNo" label="工单编号" width="120">
          <template slot-scope="scope">
            <router-link
              style="color: black"
              :to="{ path: '/job/b2bJobInfo', query: { JobId: scope.row.Id } }"
              target="_blank"
              >{{ scope.row.JobNo || "--" }}</router-link
            >
          </template>
        </el-table-column>
  
        <el-table-column
          property="Title"
          label="标题"
          show-overflow-tooltip >
          <template slot-scope="scope">
            <span>{{ scope.row.Title || "--" }}</span>
          </template>
        </el-table-column>  
  
        <el-table-column property="IsProjectJob" label="工单类别" width="120">
          <template slot-scope="scope">
            <span>{{
              (scope.row.IsFreeToB2b == 1
                ? scope.row.IsProjectJob == 1
                  ? "自由转B2b项目"
                  : "自由转B2b标准"
                : scope.row.IsProjectJob == 1
                ? "项目"
                : "标准") 
            }}</span>
          </template>
        </el-table-column>
  
       <el-table-column property="JobTag" label="SaaS/灵工" width="90">
          <template slot-scope="scope">
            <span :style="(scope.row.JobTag > 0?'color:red':'')" >{{ scope.row.JobTag > 0 ? "是" : "否" }}</span>
          </template>
        </el-table-column>  
      </el-table>
      <div style=" margin-top: 10px; overflow:hidden">
        <div style="float: left;" v-show="jobList.length">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listCount">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </template> 
  
  <script>
  import {
      getJobSendJobList, // 添加统计
  } from "@/service/jobStatistics";
  export default { 
    data() {
      return {
        dialogIsShow: false,
        listLoading: false,
  
        startTime:"",
        endTime:"",
        jobType:0,
        jobList: [],
        listCount: 0,
        pageNum: 1,
        pageSize: 10,
      };
    },
    methods: {
      openDia(startTime,endTime,jobType) {
        this.startTime=startTime;
        this.endTime=endTime;
        this.jobType=jobType;
        this.pageNum = 1;
        this.dialogIsShow = true;
        this.loadList();
      },
  
      handleSizeChange(val) {
        if (this.listLoading) return;
        this.pageNum = 1;
        this.pageSize = val;
        this.loadList();
      },
      handleCurrentChange(val) {
        if (this.listLoading) return;
        console.log(val);
        this.pageNum = val;
        this.loadList();
      },
  
      async loadList() {
        this.listLoading = true;
  
        var data = {
          StartDate:this.startTime,
          EndDate:this.endTime,
          PageNum: this.pageNum,
          PageSize: this.pageSize,
          JobType:this.jobType,
          platform: "pcweb",
        };
  
        console.log(data);
  
        let res = await getJobSendJobList(data);
        this.listLoading = false;
        if (res.Result != 1) {
          return this.$message.error("获取失败请联系开发人员");
        }
        console.log(res);
        if (res.Result != 1) {
          return this.$message.error(res.Message);
        }
        //this.$message({ message: res.Message, type: "success" });
  
        this.$nextTick(() => {
          this.listCount = res.Data.TotalCount;
          this.jobList = res.Data.JobList;
          console.log("listCount:" + this.listCount);
          console.log(this.jobList);
        });
      },
    },
  };
  </script>
      
  <style scoped>
  .gradHeader {
    background: red !important;
  }
  </style>